export default __webpack_public_path__ + "static/city-e726a98cd660e282fd5c4843f4bac196.svg";